import React from 'react'
import { FormattedMessage } from 'react-intl'

import BaseSupSub from './BaseSupSub'

import './GameInfo.css'

const GameInfo = (props) => {

  let bssKeys = props.gameInfo.bss ? Object.keys(props.gameInfo.bss) : ''

  return (
    <section id="game-info">
      <h1>
        <FormattedMessage id="game.info.h1.gameDescription" />
      </h1>
      {props.gameName && (
        <div>
          <h2>
            <FormattedMessage id="game.info.h2.name" />
          </h2>
          <div className="gif-content">{props.gameName}.</div>
        </div>
      )}
      {props.gameInfo.bss && (
        <div>
          <h2>
            <FormattedMessage id="game.info.h2.elementDescription" />
          </h2>
          <div className="bss">
            <div className="bss-model">
              <BaseSupSub data={{ base: bssKeys[0], sup: bssKeys[1], sub: bssKeys[2] }} className="bss-border" />
            </div>
            <dl className="bss-fields">
              <dt>{bssKeys[0]}:</dt><dd>{props.gameInfo.bss[bssKeys[0]]}</dd>
              <dt>{bssKeys[1]}:</dt><dd>{props.gameInfo.bss[bssKeys[1]]}</dd>
              <dt>{bssKeys[2]}:</dt><dd>{props.gameInfo.bss[bssKeys[2]]}</dd>
            </dl>
          </div>
        </div>        
      )}
      {props.gameInfo.goal && (
        <div>
          <h2>
            <FormattedMessage id="game.info.h2.goal" />
          </h2>
          <div className="gif-content">{props.gameInfo.goal}</div>
        </div>
      )}
      {props.gameInfo.description && props.gameInfo.description.length > 0 && (
        <div>
          <h2>
            <FormattedMessage id="game.info.h2.description" />
          </h2>
          {props.gameInfo.description.map((v,i) => <p key={i}>{v}</p>)}          
        </div>
      )}
      {props.gameInfo.workareas && props.gameInfo.workareas.length > 0 && (
        <div>
          <h2>
            <FormattedMessage id="game.info.h2.workareas" />
          </h2>
          <ul>
            {props.gameInfo.workareas.map((v,i) => <li key={i}>- {v}.</li>)}
          </ul>
        </div>
      )}
    </section>
  );
};

export default GameInfo


// WEBPACK FOOTER //
// ./src/components/GameInfo.js